export const environment =
{
	production:				false,
	ambient:				"MejorCDT",
	widgetErrorTelemetry:	true, // KK-304
	language:				"ES",
	baseUrlAccess:			"https://test-api-kore.kravata.co/api/v1", 
	baseUrlClient:			"https://test-api-kore.kravata.co/api/v1",
	baseUrlCustodian:		"https://test-api-kore.kravata.co/api/v1",
	baseUrlBusiness:		"https://test-api-kore.kravata.co/api/v1",
	baseUrlTransaction:		"https://test-api-kore.kravata.co/api/v1",
	baseMFEUrl:				"https://frwidget-mejorcdt-test.kravata.co",
	baseCoreUrl:			"https://frwidget-demo-test.kravata.co",
	urlFiles:				"https://test-admin.internal.kravata.co/api/utils/loadfiles",
	apiUrlFiles:			"https://testapi.kravata.co/api",
	brebRechargeKey:		"@POWWI1801641846"
};